import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentBankAccount } from '../../../../../models/entities/payment-bank-account';
import { UnifiedBankAccount } from '../../../../../models/entities/unified-bank-account';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { GrowlerService } from '../../../../../services/growler.service';

export interface BankAccountPropertiesDialogInput
{
    bankAccount: UnifiedBankAccount | PaymentBankAccount;
}

export interface BankAccountPropertiesDialogResult
{
    success: boolean;
}

@Component({
    selector: 'app-bank-account-properties',
    templateUrl: './bank-account-properties.component.html',
})
export class BankAccountPropertiesComponent implements OnInit
{

    public sendingUpdate: boolean = false;
    public bankAccountPropertiesForm: FormGroup;

    constructor(
            private _bankAccountsService: BankAccountsService,
            private _dialogRef: MatDialogRef<BankAccountPropertiesComponent>,
            private _growlerService: GrowlerService,
            private _formBuilder: FormBuilder,
            @Inject(MAT_DIALOG_DATA) public data: BankAccountPropertiesDialogInput,
    ) {
    }

    ngOnInit() {
        this.bankAccountPropertiesForm = this._formBuilder.group({
            friendlyName: [this.data.bankAccount.friendlyName],
        });
    }

    submit() {
        if (!this.bankAccountPropertiesForm.valid) {
            return;
        }

        this.sendingUpdate = true;
        this._bankAccountsService
                .putBankAccountProperties(
                        null,
                        this.data.bankAccount.id,
                        this.bankAccountPropertiesForm.value,
                )
                .subscribe(() => {
                    this._dialogRef.close(<BankAccountPropertiesDialogResult>{success: true});
                }, () => {
                    this._growlerService.error('Error Updating Account', 'An error occurred while trying to update this bank account. Please try again.');
                    this.sendingUpdate = false;
                });
    }

    closeDialog() {
        this._dialogRef.close(<BankAccountPropertiesDialogResult>{success: false});
    }

}
